import { privateHttp } from "~/config/axios";

// MCP 문서 기반: 브랜드페이 Access Token 발급 요청/응답 인터페이스
export interface BrandpayTokenRequest {
  code: string;
  customerKey: string;
  grantType: "AuthorizationCode";
}

export interface BrandpayTokenResponse {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
}

// MCP 문서 기반: 브랜드페이 Access Token 발급 API
export const issueBrandpayToken = async (
  data: BrandpayTokenRequest
): Promise<BrandpayTokenResponse> => {
  const response = await privateHttp.post<BrandpayTokenResponse>(
    "/payment/toss/brandpay/token",
    data
  );
  return response.data;
};

// 브랜드페이 인증 상태 확인 API
export const checkBrandpayAuthStatus = async (
  customerKey: string,
  customerAuthCode: string
): Promise<{
  status: "PENDING" | "DONE" | "FAILED";
  customerToken: string | null;
  expiresIn: number | null;
}> => {
  const response = await privateHttp.post(
    "/payment/toss/brandpay/auth-status",
    {
      customerKey,
      customerAuthCode,
    }
  );
  return response.data;
};

// 브랜드페이 결제 승인 API
export const approveBrandpayPayment = async (
  paymentKey: string,
  orderId: string,
  amount: number
): Promise<any> => {
  const response = await privateHttp.post("/payment/toss/brandpay/approve", {
    paymentKey,
    orderId,
    amount,
  });
  return response.data;
};
